import { IPendingUsersModalProps } from "./interface";
import React, { useState, useEffect } from "react";
import store from "@/redux-store";
import { ZViewUserRequestModal } from "@molecules/ZViewUserRequestModal";
import {
	AddCompanyUserRequest,
	UserAccess,
	UserRole
} from "@/Contracts/Users";
import { ZMessage } from "@molecules";
import {
	acceptPendingUser,
	acceptVendorPendingUser,
	rejectPendingUser
} from "@/Services/User";
import {
	ChildEntityHydrationParams,
	includeChildEntities,
	Name
} from "@/Contracts";
import NotificationFeedActionCreators from "@/Actions/Others/NotificationFeed";

const PendingUserModal: React.FC<IPendingUsersModalProps> = ({
	id,
	onClose
}) => {
	const state = store.getState();
	const { billingInfo, currentPlan, subscriptionDetails } = {
		billingInfo: state.user.billingInfo,
		currentPlan: state.user.subscriptions.find(plan => plan.current_plan),
		subscriptionDetails: state.user.subscriptionDetails
	};
	const [viewUserRequestModalId, setViewUserRequestModalId] = useState<
		string | null
	>(null);
	const handleAddUser = async (
		userId: string,
		username: string,
		useremail: string,
		role: UserRole,
		level: UserAccess
	) => {
		try {
			const addCompanyUserRequest = new AddCompanyUserRequest();
			const companyUserName = new Name();
			companyUserName.first = username?.split(" ")[0];
			companyUserName.last = username?.split(" ")[1];
			addCompanyUserRequest.name = companyUserName;
			addCompanyUserRequest.role = role;
			addCompanyUserRequest.email = useremail.trim();
			addCompanyUserRequest.access_level = level;
			await acceptPendingUser(userId, addCompanyUserRequest);
			ZMessage.success("User added successfully");
			onClose();
			refreshNotificationsFeed();
		} catch (error) {
			console.error(error);
		}
	};
	const handleAddVendor = async (pendingUserId: string) => {
		try {
			const includedChildEntities = includeChildEntities([
				ChildEntityHydrationParams.VENDORS_ALL,
				ChildEntityHydrationParams.USERS_ALL
			]);
			const pendingUser = await acceptVendorPendingUser(
				pendingUserId,
				includedChildEntities
			);
			return pendingUser;
		} catch (error) {
			console.error(error);
			return null;
		}
	};
	const handleRejectUser = async (pendingUserId: string) => {
		try {
			await rejectPendingUser(pendingUserId);
			onClose();
			refreshNotificationsFeed();
		} catch (error) {
			console.error(error);
		}
	};
	useEffect(() => {
		setViewUserRequestModalId(id);
	}, []);
	const refreshNotificationsFeed = () =>
		store.dispatch(NotificationFeedActionCreators.getNotificationFeed());
	return (
		<ZViewUserRequestModal
			billingInfo={billingInfo}
			currentPlan={currentPlan}
			subscriptionDetails={subscriptionDetails}
			visible={!!viewUserRequestModalId}
			onClose={onClose}
			pendingUserId={viewUserRequestModalId ?? ""}
			showGoBackButton={false}
			addUser={handleAddUser}
			addVendor={handleAddVendor}
			rejectUser={handleRejectUser}
			size="lg"
		/>
	);
};

export default PendingUserModal;
